<div class=" mt-3">
  <p-breadcrumb class="max-w-full" [model]="items" [home]="home"></p-breadcrumb>
</div>

<div class="grid mt-3">

  <!-- profile menu -->
  <div class="col-3">
    <div class="profile-menu">
      <div>
        <span style="color: white; display: flex; justify-content: center;">
          <span><p-avatar icon="pi pi-user" styleClass="mr-2 bg-gray-300 fs-6" size="xlarge" shape="circle"></p-avatar></span>
        </span>
        <div class="fw-semibold fs-5 "  *ngIf="!nameIsEdited" style="display: flex; align-items: stretch; text-align: center; position: relative;">
          <span style="cursor: default">
            {{ patientData.name }}
          </span>
          <svg style=" color: #0b7fb8 !important; padding: 0px; height: 2rem; width: 2rem; cursor: pointer; padding-left: 10px;" width="16px" height="16px" (click)="editName()" class="btn-secondary--check-edit  svg-inline--fa fa-pen-to-square text-body fs-5" aria-hidden="true" focusable="false" data-prefix="far" data-icon="pen-to-square" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152V424c0 48.6 39.4 88 88 88H360c48.6 0 88-39.4 88-88V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V424c0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40V152c0-22.1 17.9-40 40-40H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H88z"></path></svg>
        </div>
        <div *ngIf="nameIsEdited" style="display: flex; align-items: flex-end; margin-top: 1rem">
          <input class="form-control" (ngModelChange)="nameChanged = true" [(ngModel)]="tempName" />
          <span class="btn-secondary-edit ms-2  btn-secondary--check-edit" (click)="saveName()">
            <svg class="svg-inline--fa fa-circle-check fs-5" aria-hidden="true" focusable="false" data-prefix="far" data-icon="circle-check" role="img" viewBox="0 0 512 512" data-fa-i2svg="">
              <path fill="currentColor" d="M243.8 339.8C232.9 350.7 215.1 350.7 204.2 339.8L140.2 275.8C129.3 264.9 129.3 247.1 140.2 236.2C151.1 225.3 168.9 225.3 179.8 236.2L224 280.4L332.2 172.2C343.1 161.3 360.9 161.3 371.8 172.2C382.7 183.1 382.7 200.9 371.8 211.8L243.8 339.8zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path>
            </svg>
          </span>
          <span class="btn-secondary-edit ms-2  btn-secondary--check-cancel" (click)="cancel()" style="padding:0px; height:2rem;width: 2rem">
            <svg class="svg-inline--fa fa-circle-xmark fs-5" aria-hidden="true" focusable="false" data-prefix="far" data-icon="circle-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M175 175C184.4 165.7 199.6 165.7 208.1 175L255.1 222.1L303 175C312.4 165.7 327.6 165.7 336.1 175C346.3 184.4 346.3 199.6 336.1 208.1L289.9 255.1L336.1 303C346.3 312.4 346.3 327.6 336.1 336.1C327.6 346.3 312.4 346.3 303 336.1L255.1 289.9L208.1 336.1C199.6 346.3 184.4 346.3 175 336.1C165.7 327.6 165.7 312.4 175 303L222.1 255.1L175 208.1C165.7 199.6 165.7 184.4 175 175V175zM512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM256 48C141.1 48 48 141.1 48 256C48 370.9 141.1 464 256 464C370.9 464 464 370.9 464 256C464 141.1 370.9 48 256 48z"></path></svg>
          </span>
        </div>
      </div>
     
     
    
      <div >
        <span>
          <span> MRN: </span>
          <span> {{ patientData.mrn || 'No Medical Record Number for this patient' }}</span>
        </span>
      </div>
      <div *ngIf="patientData.patientApplication.applicationStatus == 'ACCEPTED'">
        <span class="fw-semibold title mt-4" style="justify-content: center;">
          <span style=" margin-top: 0.1rem;"> Appointment Date </span>
        </span>
        <span style="white-space: nowrap"> {{ (patientData.appointmentDate | date:"MMM dd, yyyy 'at' hh:mm a") || "No Appointment Date for this patient"  }}</span>
      </div>
    </div>
  </div>

  <!-- contact menu -->
  <div class="col-5">
    <div class="p-3 contact-menu">
      <span class="title">Basic Info</span>
      <span style="display: flex; justify-content: space-between;">
        <span class="data-container pt-2">
          <span class="sub-title">Gender</span>
          <span class="fw-semibold  mt-2" pTooltip="{{ patientData.gender }}" tooltipPosition="bottom">{{ patientData.gender }}</span>
        </span>
        <span class="data-container  pt-2">
          <span class="sub-title">Date of Birth </span>
          <span class="fw-semibold mt-2" style="white-space: nowrap" pTooltip="{{ patientData.birthDate | date : 'dd MMMM yyyy' }}" tooltipPosition="bottom">{{ patientData.birthDate | date : "dd MMMM yyyy" }}</span>
        </span>
        <span class="data-container pt-2">
          <span class="sub-title">National ID</span>
          <span class="fw-semibold  mt-2" pTooltip="{{ patientData.idNumber }}" tooltipPosition="bottom">{{ patientData.idNumber }}</span>
        </span>
      </span>
      <span class="title mt-4">Contact Info</span>
      <span style="display: flex; justify-content: space-between;">
        <span class="data-container pt-2">
          <span class="sub-title"> Home Address</span>
          <span class="fw-semibold  mt-2" pTooltip="{{ patientData.cityName }}" tooltipPosition="bottom">{{ patientData.cityName }}</span>
        </span>
        <span class="data-container pt-2 ">
          <span class="sub-title">Patient phone:</span>
          <span class="fw-semibold  mt-2" pTooltip="{{ patientData.primaryMobileNo }}" tooltipPosition="bottom">{{ patientData.primaryMobileNo }}</span>
        </span>
        <span class="data-container pt-2 ">
          <span class="sub-title">Email Address</span>
          <span class="fw-semibold  mt-2" pTooltip="{{ patientData.email }}" tooltipPosition="bottom">{{ patientData.email }}</span>
        </span>
      </span>
    </div>
  </div>

  <!-- notes menu -->
  <div class="col-4">
    <div class="p-3 contact-menu">
      <span class="fw-semibold">Patient Notes</span>
      <div class="notes-area mt-3">
        <div class="p-3 " style="overflow: hidden; text-align: end">
          {{ patientData.patientApplication.notes || "No notes found" }}
        </div>
        <span (click)="showDialog()" class="notes-btn fw-medium p-3">See All</span>
      </div>
    </div>
  </div>
</div>

<div class=" mb-3 grid">
  <div class="col-8 mt-2" >
    <div class=" p-3" style="background-color: white; border-radius: 11px">
      <p class="fs-4 fw-semibold">Management Section</p>
      <div>
        <div [ngClass]="patientData.patientApplication.applicationStatus" class="fw-medium fs-5 px-5 p-3">
          <span style="text-align: left"> Current Application Status: </span>
          <span style="text-align: right"> {{ patientData.patientApplication.applicationStatus  || "No Application Found"}} </span>
        </div>
        <div class="management-container">
          <form [formGroup]="applicationForm" fxLayout="column" fxLayoutAlign="center center" (ngSubmit)="submitApplication()" name="applicationForm">
            <div class="field-styles">
              <label class="pe-3">Application Status</label>
              <div class="card flex justify-content-center">
                <p-dropdown [options]="options" formControlName="caseStatus" [styleClass]="'w-100'" name="caseStatus" placeholder="Select Status"></p-dropdown>
              </div>
            </div>
            <div *ngIf="!patientData.mrn || (patientData.mrn && patientData.mrn.length !=10)" class="field-styles">
              <label class="pe-3">*MRN</label>
              <input type="text" placeholder="Enter MRN Number" minlength="10" maxlength="10" (keydown)="validateNumber($event)"
                     [class]="'w-100'" formControlName="mrn" pInputText name="mrn" required/>
            </div>

            <span *ngIf="applicationForm.get('caseStatus')?.value === 'ACCEPTED'" class="field-styles">
              <label class="pe-3">Appointment Date</label>
              <p-calendar formControlName="appointmentDate" [showTime]="true" name="appointmentDate"
                          dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="initDate" hourFormat="12"
                          [styleClass]="'w-100 calendar-icon'"></p-calendar>
            </span>
            <p-button label="Submit" (click)="submitApplication()" [disabled]="applicationForm.invalid || !patientData.patientApplication.id"> </p-button>
          </form>
        </div>
      </div>
    </div>

  </div>
  <div class="col-4">
        <app-inr-patient-attachments [patientData]="patientData"></app-inr-patient-attachments>
  </div>
</div>
<p-dialog header="Patient Notes" [(visible)]="visible" [style]="{width: '50vw', textAlign: 'end'}" [modal]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true">
  <p>
    {{ patientData.patientApplication.notes || "No notes found" }}
  </p>
</p-dialog>
